import { render, staticRenderFns } from "./ImprimirPedidoOs.vue?vue&type=template&id=187ad5a4&scoped=true&"
import script from "./ImprimirPedidoOs.vue?vue&type=script&lang=js&"
export * from "./ImprimirPedidoOs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ad5a4",
  null
  
)

export default component.exports